import { createSlice } from "@reduxjs/toolkit";

const RedeemOrdersSlice = createSlice({
  name: "redeemOrders",
  initialState: {
    loading: false,
    data: [],
    diamondPointOrdersData: [],
    customerDiamondPointsData: [],
    total: 0,
    totalDiamondPoint: 0,
    totalCustomerDiamondPoints: 0,
    message: "",
    error: null,
    lastAction: null,
    otpData: null,
    benefitsData: [],
    totalBenefits: 0,
  },
  reducers: {
    fetchRedeemOrdersRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchRedeemOrdersSuccess: (state, action) => {
      state.loading = false;
      state.data = JSON.parse(JSON.stringify(action.payload.orders));
      state.total = action.payload.total;
      state.message = action.payload.message;
    },
    fetchRedeemOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createRedeemRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.lastAction = "createRedeem";
    },
    createRedeemSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.lastAction = "createRedeem";
    },
    createRedeemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.lastAction = "createRedeem";
    },

    // fetch diamond point orders
    fetchDiamondPointOrdersRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchDiamondPointOrdersSuccess: (state, action) => {
      state.loading = false;
      state.diamondPointOrdersData = JSON.parse(
        JSON.stringify(action.payload.orders),
      );
      state.totalDiamondPoint = action.payload.total;
      state.message = action.payload.message;
    },
    fetchDiamondPointOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // In RedeemOrdersSlice
    verifyDiamondPointOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.lastAction = "verifyDiamondPointOrder";
    },
    verifyDiamondPointOrderSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.lastAction = "verifyDiamondPointOrder";
    },
    verifyDiamondPointOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.lastAction = "verifyDiamondPointOrder";
    },
    createReferralRedeemRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.lastAction = "createReferralRedeem";
      state.otpData = null;
    },
    createReferralRedeemSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.otpData = action.payload.data;
      state.lastAction = "createReferralRedeem";
    },
    createReferralRedeemFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.lastAction = "createReferralRedeem";
    },
    fetchReferralOrdersRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchReferralOrdersSuccess: (state, action) => {
      state.loading = false;
      state.data = JSON.parse(JSON.stringify(action.payload.orders));
      state.total = action.payload.total;
      state.message = action.payload.message;
    },
    fetchReferralOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    verifyReferralOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
      state.lastAction = "verifyReferralOrder";
    },
    verifyReferralOrderSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
      state.lastAction = "verifyReferralOrder";
    },
    verifyReferralOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.lastAction = "verifyReferralOrder";
    },
    fetchBenefitsRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchBenefitsSuccess: (state, action) => {
      state.loading = false;
      state.benefitsData = JSON.parse(JSON.stringify(action.payload.benefits));
      state.totalBenefits = action.payload.total;
      state.message = action.payload.message;
    },
    fetchBenefitsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearRedeemState: (state) => {
      state.error = null;
      state.message = "";
      state.lastAction = null;
    },

    fetchCustomerDiamondPointsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCustomerDiamondPointsSuccess: (state, action) => {
      state.loading = false;
      state.customerDiamondPointsData = JSON.parse(
        JSON.stringify(action.payload.records),
      );
      state.totalCustomerDiamondPoints = action.payload.total;
      state.message = action.payload.message;
    },
    fetchCustomerDiamondPointsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchRedeemOrdersRequest,
  fetchRedeemOrdersSuccess,
  fetchRedeemOrdersFailure,
  createRedeemRequest,
  createRedeemSuccess,
  createRedeemFailure,
  fetchDiamondPointOrdersRequest,
  fetchDiamondPointOrdersSuccess,
  fetchDiamondPointOrdersFailure,
  verifyDiamondPointOrderRequest,
  verifyDiamondPointOrderSuccess,
  verifyDiamondPointOrderFailure,
  createReferralRedeemRequest,
  createReferralRedeemSuccess,
  createReferralRedeemFailure,
  fetchReferralOrdersRequest,
  fetchReferralOrdersSuccess,
  fetchReferralOrdersFailure,
  verifyReferralOrderRequest,
  verifyReferralOrderSuccess,
  verifyReferralOrderFailure,
  fetchBenefitsRequest,
  fetchBenefitsSuccess,
  fetchBenefitsFailure,
  clearRedeemState,
  fetchCustomerDiamondPointsRequest,
  fetchCustomerDiamondPointsSuccess,
  fetchCustomerDiamondPointsFailure,
} = RedeemOrdersSlice.actions;

export default RedeemOrdersSlice.reducer;
